<template>
  <div>
    <button @click="messages" style="background: rebeccapurple">message</button>
    <button @click="toasts" style="background: forestgreen">toast</button>
    <button @click="confirms" style="background: deepskyblue">confirm</button>
    <hz-select v-model="val" value="333">
      <hz-select-option
        v-for="item in data"
        :label="item.label"
        :value="item.value"
        :key="item.label"
        :changeValue.sync="pageSize"
        :changeLabel.sync="val"/>
    </hz-select>
    <hz-radio v-model="value" :changeValue.sync="value" :option="options"/>

    <!--<hz-checkbox-group :model="list">-->
      <!--<hz-checkbox label="上海"/>-->
      <!--<hz-checkbox label="北京"/>-->
      <!--<hz-checkbox label="广州"/>-->
      <!--<hz-checkbox label="深圳"/>-->
    <!--</hz-checkbox-group>-->
    <!--<img src="../assets/loading1.gif"/>-->
    <!--<img src="../assets/loading2.gif"/>-->
    <!--<img src="../assets/loading3.gif"/>-->
    <!--<img src="../assets/loading4.gif"/>-->
    <hz-checkbox-group v-model="lists">
      <hz-checkbox v-for="item in chooseList" :label="item" :key="item" :chooseList.sync="lists" :isDisabled="item === '北京'||item === '上海'"/>
    </hz-checkbox-group>
    <button @click="loading">点击加载图标</button>
    <hz-time-picker  :timeValue.sync="time"/>
    <test11 :dateValue.sync="date"/>

    <!--<hz-table :data="dataList">-->
      <!--<hz-table-item label="ID" prop="id"/>-->
      <!--<hz-table-item label="名字" prop="name"/>-->
      <!--<hz-table-item label="年龄" prop="age"/>-->
      <!--<hz-table-item label="caozuo">-->
        <!--<button @click="deletes" >sha</button>-->
      <!--</hz-table-item>-->
    <!--</hz-table>-->
    <tab :data="dataList" :thProp="propList"  @saveEdit="save">
      <template slot-scope="scope">
      <button @click="deletes(scope.row.id,scope.index)">删除</button>
      <button @click="deletes(scope.row)">sss</button>
    </template>
    </tab>
    <!--<tables :dataTable="list" :propList="propList"/>-->
    <!--<hz-tree :data="treeData">-->
      <!--<template slot-scope="scope" @items="items">-->
        <!--<button @click.stop="edit(scope.row.id)" >xiugai</button>-->
      <!--</template>-->
    <!--</hz-tree>-->
    <!--<ul v-for="(item) in treeData">-->
      <!--<hz-tree :data="item">-->
          <!--<button @click="slot">修改</button>-->
      <!--</hz-tree>-->
    <!--</ul>-->
    <test7 :treeData="treeData" @nodeObject="getNodesd">
      <button @click="sss">修改</button>
    </test7>
  </div>
</template>

<script>
  import tab from './tab'
  import test11 from './datePicker'
  import tables from './test11'
  import {getList,postModify} from "../api/api";
  import test7 from './test7'
  export default {
    components:{
      test11,
      tab,
      tables,
      test7
    },
      data(){
        return{
          data:[
            {label:'10条/页',value:'10'},
            {label:'20条/页',value:'20'},
            {label:'30条/页',value:'30'},
            {label:'40条/页',value:'40'}
            ],
          val:'',
          pageSize:0,
          value:'',
          options:[
            {label: '选项1', value: '1', isDisabled: true},
            {label: '选项2', value: '2'},
            {label: '选项3', value: '3'}
          ],
          chooseList:['上海', '北京', '广州', '深圳'],
          lists:[],
          isShow:false,
          time:'',
          date:'',
          dataList:{},

            // [
            // {id:'1',name:'通知1',age:'34'},
            // {id:'2',name:'通知2',age:'39'},
            // {id:'3',name:'通知13',age:'99'},
            // {id:'4',name:'通知4',age:'39'},
            // {id:'5',name:'通知5',age:'9'},
            // {id:'6',name:'通知6',age:'399'},
            // {id:'7',name:'通知7',age:'399'},
            // {id:'8',name:'通知8',age:'399'},
            // {id:'9',name:'通知9',age:'399'},
            // {id:'10',name:'通知10',age:'399'},
            // ],
          propList:[
            {prop:"id",label:"编号",width:100},
            // {prop:"name",label:"名称",width:100,sortable:true},
            // {prop:"age",label:"名称",width:100,sortable:true},
            {prop:"content",label:"内容",width:100,sortable:true},
            {prop:"createBy",label:"创建人",width:100,sortable:true},
            {prop:"createTime",label:"创建时间",width:100,sortable:true},
            {prop:"lastModifyBy",label:"修改人",width:100,sortable:true},
            {prop:"lastModifyTime",label:"修改时间",width:100,sortable:true},
            {prop:"title",label:"标题",width:100,sortable:true},
            {label:"操作",width:100}
          ],
          searchQuery: '',
          list:{},
          treeData:
            [{
              id:1,
              name: 'My Tree',// 一级数据
              children: [
                { id:2,name: 'hello2',children:[]},// 二级数据
                { id:3,name: 'wat2',children:[]},
                {
                  id:4,
                  name: 'child folder2',
                  children: [
                    {
                      id:5,
                      name: 'child folder3',// 三级数据
                      children: [
                        {id:6, name: 'hello4',children:[]},// 四级数据
                        { id:7,name: 'wat4',children:[]}
                      ]
                    },
                    { id:8,name: 'hello3',children:[]},// 三级数据
                    { id:9,name: 'wat3',children:[]},
                    {id:10,name: 'child folder3',
                      children: [
                        { id:11,name: 'hello4',children:[]},// 四级数据
                        { id:12,name: 'wat4',children:[]}
                      ]
                    }
                  ]
                }
              ]
            }]
        }
      },
      watch:{
        time(data){
          console.log(data);
        },

        date(data){
          console.log(data);
        },
        value(data){
          console.log(data);
        },
      },
      methods:{
        getNodesd(data){
          console.log(data);
        },
        sss(){
          console.log(121211);
        },
        save(data){
          console.log(data);
          postModify(data[0]).then(res =>{
              console.log(res);
          });
        },
        toasts(){
          // this.$toast({message:'fsdf',duration:2000});
          this.$toast('wwwwerew');
        },
        test(){
        },
        confirms(){
          // this.$confirm('确定删除吗').then(()=>{
          //   console.log(323);
          // })
          this.$confirm('我是');
        },
        messages(){
          this.$message({message:'成功',type:'WARING',duration:3000});
        },
        loading(){
          this.openLoading('加载中');
          setTimeout(()=>{
            this.closeLoad();
          },2000)
        },
        deletes(data,index){
          console.log(data);
          console.log(index);
        }
      },
      created(){
        getList().then(res =>{
          this.dataList = res.data.data;
        });
        // this.$http.get('../../static/a.json').then(res =>{
        //     // this.dataList = res.data.data;
        // });
        this.$http.get('../../static/datalist.json').then(res =>{
          this.list = res.data;
        })
      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/test.vue